let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3nC6c")).then(() => parcelRequire('cfBcH'));